<!-- Wrapper: full width on mobile, ~50% centered on desktop -->
<div class="w-full md:max-w-[725px] mx-auto">
    <section class="goodometer bg-[var(--p-primary-500)] text-white
           rounded-none md:rounded-full
           px-5 md:px-10 py-4 md:py-5
           flex flex-wrap md:flex-row items-center justify-center
           gap-1 md:gap-3 shadow-sm" aria-label="Goodometer total raised">

        <span class="font-bold tracking-tight text-lg">Goodometer™</span>

        <span class="font-extrabold text-2xl md:text-3xl leading-none !font-noto-serif ml-2">
            <ng-container *ngIf="amount() !== null; else loading">
                {{ amount() | currency:'USD':'symbol':'1.0-0' }}
            </ng-container>
        </span>

        <span class="text-white/90 md:ml-1 leading-snug text-lg">
            raised for schools and nonprofits!
        </span>
    </section>
</div>

<ng-template #loading>
    <!-- PrimeNG skeleton while loading -->
    <p-skeleton width="160px" height="28px" styleClass="border-none rounded-md"></p-skeleton>
</ng-template>